var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 40.125V64.0326C29.125 70.5736 34.445 75.875 41.0231 75.875C47.5952 75.875 52.9271 70.5736 52.9271 64.0326V40.125M85.5 40.125L61.7097 75.875M61.7097 40.125L85.5 75.875",
    stroke: "#062F85",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.108 3H14.8919C8.32418 3 3 8.32418 3 14.8919V101.108C3 107.676 8.32418 113 14.8919 113H101.108C107.676 113 113 107.676 113 101.108V14.8919C113 8.32418 107.676 3 101.108 3Z",
    stroke: "#062F85",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxDev);
export default __webpack_public_path__ + "static/media/ux-dev.f26b2709977bf681e385a0f22f6ca0bc.svg";
export { ForwardRef as ReactComponent };